import React from "react";
import "./App.scss";
import "antd/dist/antd.css";
import { Layout } from "antd";
//import IntegrationsPage from "./components/pages/IntegrationsPage/IntegrationsPage";
//import TemplatesLibraryPage from "./components/pages/TemplatesLibraryPage/TemplatesLibraryPage";
import SideBar from "./components/SideBar/SideBar";
import { Provider } from "mobx-react";
import UserStore from "./stores/UserStore";
import RouterStore from "./stores/RouterStore";
import PagesWrapper from "./components/PagesWrapper/PagesWrapper";
import Api from "./services/Api";
import TemplatesStore from "./stores/templatesStore";
//import { BrowserRouter as Router} from "react-router-dom";
import { Router } from "react-router";
import { createBrowserHistory } from "history";

const { Content, Footer } = Layout;
const routerStore = new RouterStore();
const api = new Api();
const userStore = new UserStore(api);
const templatesStore: TemplatesStore = new TemplatesStore(api);
const stores = {
  routerStore,
  api,
  templatesStore,
  userStore
};
const history = createBrowserHistory();

const App: React.FC = () => {
  return (
    <Provider {...stores}>
      <Router history={history}>
        
        <Layout style={{ minHeight: "100vh" }}>
          <SideBar />
          <Layout>
            <Content style={{ margin: "16px 16px 0px 16px" }}>
              {/* <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>Admin</Breadcrumb.Item>
                <Breadcrumb.Item>Integrations</Breadcrumb.Item>
                <Breadcrumb.Item>Plugins</Breadcrumb.Item>
              </Breadcrumb> */}

              <div
                style={{
                  padding: 24,
                  background: "#fff",
                  height: "100%"
                }}
              >
                {/* <IntegrationsPage /> */}

                <PagesWrapper />
              </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>
              WPMailer © 2018 Created by Gilad Takoni
            </Footer>
          </Layout>
        </Layout>
      </Router>
    </Provider>
  );
};

export default App;
